(async () => {
  if (!customElements.get('product-details')) {
    const { default: Swiper, A11y, Pagination, EffectFade } = await import('swiper');

    Swiper.use([A11y, Pagination, EffectFade]);

    class ProductDetails extends HTMLElement {
      constructor() {
        super();
        this.swiper = this.querySelector('[data-swiper]');
        this.swiperSlideLabels = this.querySelectorAll('.swiper-slide');

        // Stop when the swiper is not found
        if (!this.swiper) return false;

        // Default to improve user experience
        this.swiperOptions = {
          threshold: 10,
          a11y: true,
          allowTouchMove: false,
          autoHeight: Shopify.designMode ? false : true,
          effect: 'fade',
          fadeEffect: {
            crossFade: true,
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: (index, className) => {
              return `
                <button class="${className} button button--tab">
                  ${this.swiperSlideLabels[index].dataset.swiperSlideLabel}
                </button>`;
            },
          },
        };

        // Check if we have extra options on the HTML
        if (this.swiper.dataset.options) {
          const options = JSON.parse(this.swiper.dataset.options);
          if (options) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...options,
            };
          }
        }

        // Call swiper with selected swiper element and options
        this.swiperInstance = new Swiper(this.swiper, this.swiperOptions);

        // Update swiper when the collapsible is opened
        const collapsibles = document.getElementsByClassName('faq-details__tab-btn');
        Array.from(collapsibles).forEach((collapsible) => {
          collapsible.addEventListener('click', () => {
            this.swiperInstance.update();
          });
        });

        this.handleDesignModeEvents();
      }

      /**
       * Handles the theme editor block change/edit event
       * @param {Object} event
       */
      handleBlockSelect({ dataset }) {
        // Check if the slide index is set
        if (!('swiperSlideIndex' in dataset)) return;

        // Set the slide index based on loop settings or not
        let swipeToSlideIndex = parseInt(dataset.swiperSlideIndex) - 1;
        if (this.swiperOptions.loop) swipeToSlideIndex = parseInt(dataset.swiperSlideIndex) + 1;

        // Slide to slide based on the data attribute from the target
        this.swiperInstance.slideTo(swipeToSlideIndex, 1000);
      }
      /**
       * Handle design mode events
       * @returns void
       */
      handleDesignModeEvents() {
        if (!Shopify.designMode) return;
        // Update the swiper when the section event is triggered
        ['shopify:section:load', 'shopify:block:select', 'shopify:block:deselect'].forEach(
          (inputEvent) => {
            window.addEventListener(inputEvent, (event) => {
              this.swiperInstance.update();
              if (this.swiperOptions.pagination) {
                this.swiperInstance.pagination.init();
                this.swiperInstance.pagination.update();
              }
              if (inputEvent === 'shopify:block:select' || inputEvent === 'shopify:block:deselect')
                this.handleBlockSelect(event.target);
            });
          }
        );
      }
    }

    window.ProductDetails = ProductDetails;

    customElements.define('product-details', ProductDetails);
  }
})();
